export const alertsConstants = {
    RENDER:     'RENDER',
    CLEAR:      'CLEAR'

};



// WEBPACK FOOTER //
// ./src/app/redux/constants/alertsConstants.js